import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@p2p/shared/utils';
import { Observable } from 'rxjs';

import { LoginData, LoginResponse } from '../entities/login-data';
import { RegisterData, RegisterResponse } from '../entities/register-data';

@Injectable({ providedIn: 'root' })
export class LoginDataService {
    private readonly http = inject(HttpClient);

    readonly loginUrl = '/public/login';
    readonly registerUrl = '/public/registration/complete';

    login(data: LoginData): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(`${environment.apiUrl}${this.loginUrl}`, data);
    }

    register(data: RegisterData): Observable<RegisterResponse> {
        return this.http.post<RegisterResponse>(`${environment.apiUrl}${this.registerUrl}`, data);
    }
}
